import consumer from "./consumer"

if(document.baseURI.match(/talkevents/)){
  consumer.subscriptions.create("MensagemExcluidaChannel", {
    received(data) {
      $(`.${data.chat}_${data.chat_id}`).hide();
    }
  });
}
